import React from 'react'

import Modules from '@/modules.js'
import store from '../state/store.js'

// import easydropdown from 'easydropdown'

export function renderModules(modules) {
  if (modules) {
    return modules.map((module) => {
      return <Modules
        key={module._key}
        type={module._type}
        module={module} />
    })
  }
}

class SelectDropdown extends React.Component {
  constructor () {
    super()
    this.selectedElement = React.createRef()
    this.edd = {}
  }
  componentDidMount() {
    const easydropdown = require('easydropdown').default
    this.edd = easydropdown(this.selectedElement.current, {});
  }
  componentWillUnmount() {
    this.edd.destroy()
  }
  renderOption(option) {
    const isSelected = option === this.props.value;

    return (
      <option key={option} value={option.replace(/\s+/g, '-').toLowerCase()} defaultValue={isSelected}>
        {option}
      </option>
    );
  }
  render () {
    const {
      options,
      name,
      placeholder
    } = this.props
    return (
      <select
        className='x'
        name={name}
        ref={this.selectedElement}>
        <option value="" data-placeholder>{placeholder}</option>
        {options.map((option, i) => (
          this.renderOption(option)
        ))}
      </select>
    )
  }
}

export function renderFields(fields) {
  const { type, placeholder, name, options } = fields
  switch (type) {
    case 'email':
      return (<input className='x' required key={name} type={type} name={name} placeholder={placeholder} />)
    case 'text':
      return (<input className='x' required key={name} type={type} name={name} placeholder={placeholder} />)
    case 'group':
      return (
        <div className='x apply__group' key={name}>
          <fieldset>
            {options.map((option, i) => (
              <label key={i} className='apply__group-single'>
                <span className='rel z2'>{option.placeholder}</span>
                <input name={name} required type='radio' id={option.name} value={option.name} label={option.placeholder} /> 
              </label>
            ))}
          </fieldset>
        </div>
      )
    case 'textarea':
      return (<textarea className='x bcw p1' rows={5} key={name} type={type} name={name} placeholder={placeholder} />)
    case 'dropdown':
      return (
        <SelectDropdown {...fields} key={name} />
      )
    default:
      return (<span />)
  }
}

export function truncate(elem, limit, after) {
  if (!elem || !limit) return
  var content = elem.trim()
  content = content.split(' ').slice(0, limit)
  content = content.join(' ') + (after ? after : '')
  return content
}

export function setBackground(color) {
  setTimeout(() => {
    store.hydrate({
      background: color
    })()
    console.log('taco', color)
  }, 300)
}